module.exports = __webpack_public_path__ + "media/img/help_center/Student_Manage_Application_04-f4cfb7f204c151bd932d611d42159ccc.jpg";